import { AbilityBuilder, Ability } from '@casl/ability';

function subjectName(item) {
  if (!item || typeof item === 'string') {
    return item;
  }
  return item.__type;
}

export default function defineRulesFor(user) {
  const { can, cannot, rules } = new AbilityBuilder();
  // 'manage' and 'all' are special keywords in CASL.
  // manage represents any action and all represents any subject
  if (!user) {
    cannot('manage', 'all');
  } else if (user?.role === 'admin') {
    can('manage', 'all');
    cannot('exam', 'Peoples');
  } else if (user?.role === 'attendant') {
    can('manage', 'Peoples');
    can('manage', 'Chats');
    can('manage', 'MedicalAppointments');
    can('manage', 'MedicalAppointmentsReports');
    can('manage', 'Pushs');
    can('manage', 'Schedules');
    can('manage', 'MedicalRecords');
    can('manage', 'MedicalRecordEvolutions');
    can('manage', 'AppointmentCategories');
    can('manage', 'AppointmentTags');
    can('manage', 'Specialties');
    can('manage', 'Dependents');
    can('show', 'AccidentReports');

    can('new', 'ClientInfoDocuments');
    can('delete', 'ClientInfoDocuments');
    can('accept', 'ClientInfoDocuments');
    can('show', 'SUSService');
    can('list', 'Corporations');
    can('show', 'Corporations');
    can('list', 'Partners');
    can('show', 'Partners');

    can('show', 'Files');
    can('list', 'PendingFiles');

    cannot('exam', 'Peoples');
    cannot('edit', 'Peoples', 'role');

    cannot('manage', 'Faqs');
    cannot('manage', 'Products');
    cannot('manage', 'Pins');
    cannot('manage', 'EpayTransactions');
    cannot('manage', 'Dashboards');
    cannot('manage', 'Cards');
    cannot('manage', 'Subscriptions');
    cannot('manage', 'Addons');
    cannot('manage', 'PackageBillings');
    cannot('manage', 'PlanBillings');
    cannot('manage', 'TourImages');
  } else if (user?.role === 'doctor') {
    if (parseInt(user?.id) === 33115) {
      can('manage', 'all');
    } else {
      can('manage', 'Schedules');
      cannot('show_calendar', 'Schedules');
      cannot('change_doctor', 'Schedules');
      cannot('edit', 'Schedules'); // médico não edita horários de trabalho
      cannot('delete', 'Schedules'); // médico não exclui horários de trabalho

      can('manage', 'MedicalRecordEvolutions');

      can('list', 'MedicalAppointments');
      can('show', 'MedicalAppointments');
      can('edit', 'MedicalAppointments');
      can('list', 'MedicalAppointmentsReports');
      can('show', 'MedicalAppointmentsReports');
      can('edit', 'MedicalAppointmentsReports');
      can('list', 'MedicalRecords');
      can('show', 'MedicalRecords');
      can('list', 'Peoples');
      can('show', 'Peoples');
      can('exam', 'Peoples');
      can('list', 'Specialties');
      can('show', 'Specialties');
      can('list', 'AppointmentCategories');
      can('show', 'AppointmentCategories');
      can('new', 'AppointmentCategories');
      can('edit', 'AppointmentCategories');
      can('list', 'AppointmentTags');
      can('show', 'AppointmentTags');
      can('new', 'AppointmentTags');
      can('edit', 'AppointmentTags');
      can('list', 'Dependents');
      can('show', 'SUSRecord');
      can('show_evolution', 'SUSRecord');

      cannot('list_package', 'Peoples');
      cannot('delete_package', 'Peoples');
      cannot('edit_package', 'Peoples');
      cannot('new_package', 'Peoples');
      cannot('edit', 'MedicalRecords');
      cannot('new', 'MedicalRecords');

      cannot('new', 'ClientInfoDocuments');
      cannot('delete', 'ClientInfoDocuments');
      cannot('accept', 'ClientInfoDocuments');
      cannot('manage', 'Products');
      cannot('manage', 'Pins');
      cannot('manage', 'EpayTransactions');
      cannot('manage', 'Teams');
      cannot('manage', 'Chats');
      cannot('manage', 'Dashboards');
      cannot('manage', 'Corporations');
      cannot('manage', 'PackageBillings');
      cannot('manage', 'PlanBillings');
      cannot('manage', 'Pushs');
      cannot('manage', 'Cards');
      cannot('manage', 'Subscriptions');
      cannot('manage', 'Addons');
      cannot('manage', 'Partners');
      cannot('manage', 'Faqs');
      cannot('manage', 'TourImages');
    }
  } else if (user?.role === 'marketing') {
    cannot('manage', 'all');
    can('list', 'Pushs');
    can('new', 'Pushs');
    can('show', 'Pushs');
    cannot('edit', 'Pushs');
    cannot('delete', 'Pushs');

    can('list', 'Files');
    can('new', 'Files');
    can('show', 'Files');
    can('edit', 'Files');
    cannot('delete', 'Files');
  } else if (user?.role === 'partner') {
    cannot('manage', 'all');
  } else {
    cannot('manage', 'all');
  }
  return rules;
}

export function buildAbilityFor(user) {
  return new Ability(defineRulesFor(user), {
    // https://casl.js.org/v5/en/guide/subject-type-detection
    subjectName,
  });
  // const ability = new Ability([], { subjectName });
  // ability.update(defineRulesFor(user));
  // return ability;
}
